import React, { useEffect, useState } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { YoutubeWidgets, imageRegex } from '../../Utils/Constant';
import { equalTo, getDatabase, onValue, orderByChild, query, ref } from 'firebase/database';
import { app } from '../../Utils/Firebase';
import youtubeImage from "../../Assets/youtube.png"
import { Check } from '@mui/icons-material';
import deleteIcon from "../../Assets/delete-icon-red.svg"

function YoutubeWidget({ youtubeUrls, handleScreenPlaylist, selectedFiles, handleDeleteIcon }) {
    // const [youtubeUrls, setYoutubeUrls] = useState([]);
    // console.log("toutube==============", youtubeUrls)
    // const db = getDatabase(app);
    // const id = localStorage.getItem("id");

    // useEffect(() => {
    //     getPlaylistData();
    // }, [])


    // const getPlaylistData = async () => {
    //     try {
    //         const playlistQuery = query(ref(db, YoutubeWidgets), orderByChild('user_id'), equalTo(id));
    //         const filterData = onValue(playlistQuery, (snapshot) => {
    //             if (snapshot.exists()) {
    //                 const data = snapshot.val();
    //                 const itemsArray = Object.entries(data).map(([key, value]) => ({
    //                     ...value,
    //                     id: key
    //                 }));
    //                 setYoutubeUrls(itemsArray);
    //             } else {
    //                 console.log('No data found');
    //             }
    //         });
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }
    return (
        <>
            <div style={{ margin: 8 }}>
                <Droppable droppableId={"libarary"} key={"libarary"}>
                    {(provided, snapshot) => {
                        return (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{
                                    padding: 4,
                                    width: '100%',
                                    minHeight: '100%',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'center',
                                    gap: 20
                                }}
                            >
                                {youtubeUrls?.map((item, index) => {
                                    const isSelected = selectedFiles?.some(m => m?.url === item?.url);
                                    return (
                                        <Draggable
                                            key={item.id}
                                            draggableId={item.id}
                                            index={index}
                                            disableInteractiveElementBlocking
                                        >
                                            {(provided, snapshot) => {
                                                return (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={{
                                                            position: 'relative',
                                                        }}
                                                        onClick={() => handleScreenPlaylist(item)}
                                                    >
                                                        {isSelected && (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        left: 0,
                                                                        right: 0,
                                                                        bottom: 0,
                                                                        backgroundColor: 'black',
                                                                        opacity: 0.3,
                                                                        borderRadius: "10px",
                                                                        zIndex: 1,
                                                                    }}
                                                                // onClick={() => handleScreenPlaylist(item)}
                                                                ></div>
                                                                <Check
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '10px',
                                                                        right: '10px',
                                                                        color: 'black',
                                                                        fontSize: '20px',
                                                                        zIndex: 2,
                                                                        background: "white",
                                                                        borderRadius: "50%"
                                                                    }}
                                                                />
                                                            </>
                                                        )}
                                                        <div style={{ boxShadow: '0px 0px 5px 2px grey', width: '120px', borderRadius: '10px', background: "#cccccc" }}>
                                                            <img src={youtubeImage} alt='youtube' style={{ height: '70px', width: '100%', borderRadius: "10px" }} />
                                                            <div>
                                                                <p style={{ margin: 0 }}>{item?.name}</p>
                                                                <img
                                                                    src={deleteIcon}
                                                                    alt="delete-img"
                                                                    className='delete-widget-icon'
                                                                    onClick={(e) => {
                                                                        e.stopPropagation(); // Prevents handleScreenPlaylist from being triggered
                                                                        handleDeleteIcon(item);
                                                                    }} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </div>
                        );
                    }}
                </Droppable>
            </div>
        </>
    )
}

export default YoutubeWidget